import React, { Component } from "react";
import "./print.scss";

class QVFourEmailAndWebsiteFooter extends Component {
  render() {
    const { printVersion, hasFlippedTeam } = this.props;
    let {
      websiteURL,
      emailAddress,
      teamMembers,
      listgenUserID,
      displayEmailAddress,
      teamName,
      isMemberOfTeam,
      listgenUserFirstName,
      listgenUserLastName,
    } = this.props.agentData;
    const { mlsAreaID } = this.props.currentArea;
    //  console.log("website", websiteURL);
    const isBerkshire = false;
    const isScar = teamName === "Team Scarborough";
    const isShantiAccount = listgenUserID === "106999";
    let hasBlackBorder = false;
    if (listgenUserID === "104412") {
      hasBlackBorder = true;
    }
    let websiteEmailStyle;
    if (listgenUserID === "102843") {
      websiteEmailStyle = "larger-email-website-1";
    }
    if (emailAddress === "superadmin@listgen.com") {
      emailAddress = "SarahSullivanHomes@email.com";
    } else if (mlsAreaID === "SMA-307") {
      displayEmailAddress = "menlooaksrealestate@gmail.com";
      emailAddress = "menlooaksrealestate@gmail.com ";
    }

    if (
      listgenUserID === "103" ||
      listgenUserID === "104" ||
      listgenUserID === "105"
    ) {
      websiteURL = "SarahSullivanYourExpert.com";
    }
    let emailToUse;
    if (listgenUserID === "102512") {
      emailToUse = "Caleb.Fenner@compass.com";
    } else if (displayEmailAddress) {
      emailToUse = displayEmailAddress;
    } else {
      emailToUse = emailAddress;
    }
    let use1EmailTwoWebsites = false;
    if (listgenUserID === "106145") {
      use1EmailTwoWebsites = true;
    }
    let websiteOnly = false;
    if (listgenUserID === "109696") {
      websiteOnly = true;
    }
    let footerSpaceStyles = "";
    if (websiteURL && websiteURL.length > 36) {
      footerSpaceStyles = "footer-space-50";
    }
    if (isBerkshire) {
      if (isMemberOfTeam && teamMembers?.[1]) {
        return (
          <div
            className={`${
              printVersion
                ? "print-qv4-email-website-footer"
                : "editor-qv4-email-website-footer"
            }
              ${hasBlackBorder && "black-compiled-by"} berk-compiled-presented`}
          >
            <div>
              {isScar ? (
                <p>Compiled and Presented by {teamName}</p>
              ) : (
                <p>
                  Compiled and Presented by {listgenUserFirstName} &{" "}
                  {teamMembers[1].firstName}
                </p>
              )}
              <div className="produced-by-divider">|</div>

              <p>BERKSHIRE HATHAWAY HomeServices California Properties</p>
            </div>
            {emailToUse && <div className="berk-email">{emailToUse}</div>}
          </div>
        );
      } else {
        return (
          <div
            className={`${
              printVersion
                ? "print-qv4-email-website-footer"
                : "editor-qv4-email-website-footer"
            }
              ${hasBlackBorder && "black-compiled-by"} berk-compiled-presented`}
          >
            <div>
              <p>
                Compiled and Presented by {listgenUserFirstName}{" "}
                {listgenUserLastName}
              </p>
              <div className="produced-by-divider">|</div>
              <p>BERKSHIRE HATHAWAY HomeServices California Properties</p>
            </div>
            {emailToUse && <div className="berk-email">{emailToUse}</div>}
          </div>
        );
      }
    } else if (hasFlippedTeam && teamMembers?.[1]) {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-email-website-footer"
              : "editor-qv4-email-website-footer"
          }
            ${hasBlackBorder && "black-compiled-by"}`}
        >
          <div className="compiled-by-footer-inner-container">
            {teamMembers[1].email && (
              <p>
                Email:<span className="compiled-by-colon-padding"></span>
                {teamMembers[1].email}
              </p>
            )}
            <div className="compiled-by-footer-space" />

            <p>
              Email:<span className="compiled-by-colon-padding"></span>
              {emailAddress}
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={`${
            printVersion
              ? "print-qv4-email-website-footer"
              : "editor-qv4-email-website-footer"
          }
            ${hasBlackBorder && "black-compiled-by"}`}
        >
          {use1EmailTwoWebsites ? (
            <div className="compiled-by-footer-inner-container one-email-two-websites">
              <p>
                <span className="compiled-by-colon-padding"></span>
                {displayEmailAddress}
              </p>

              <p>
                <span className="compiled-by-colon-padding"></span>
                {websiteURL.replace(/^www./g, "")}
              </p>

              <p>
                <span className="compiled-by-colon-padding"></span>
                robert-parish.com
              </p>
            </div>
          ) : (listgenUserID === "100129" ||
              listgenUserID === "105642" ||
              listgenUserID === "106463" ||
              listgenUserID === "106550" ||
              mlsAreaID === "SCL-233E" ||
              listgenUserID === "109834" ||
              listgenUserID === "112352" ||
              listgenUserID === "102689" ||
              listgenUserID === "114393") &&
            teamMembers &&
            emailAddress &&
            teamMembers[1]?.email ? (
            <div className="compiled-by-footer-inner-container">
              <p>
                Email:<span className="compiled-by-colon-padding"></span>
                {isMemberOfTeam && listgenUserID === "102689"
                  ? teamMembers[0]?.email
                  : displayEmailAddress
                    ? displayEmailAddress
                    : emailAddress}
              </p>
              <div className="compiled-by-footer-space" />
              {teamMembers[1]?.email && (
                <p>
                  Email:<span className="compiled-by-colon-padding"></span>
                  {teamMembers[1].email}
                </p>
              )}
            </div>
          ) : listgenUserID === "102843" ? (
            <div className="compiled-by-footer-inner-container">
              <p className={websiteEmailStyle}>
                Email:<span className="compiled-by-colon-padding"></span>
                {emailToUse}
              </p>

              <div className="compiled-by-footer-space" />

              <p className={websiteEmailStyle}>
                <span className="compiled-by-colon-padding"></span>
                {mlsAreaID === "SCL-209A"
                  ? "www.cuestapark.com"
                  : mlsAreaID === "SCL-19Q"
                    ? "www.LasPalmasPark.com"
                    : mlsAreaID === "SCL-209B"
                      ? "www.VarsityPark.com"
                      : mlsAreaID === "SCL-207A"
                        ? "www.OldMountainView.com"
                        : mlsAreaID === "SCL-207B"
                          ? "DowntownMountainView.com"
                          : websiteURL.replace(/^www./g, "")}
              </p>
            </div>
          ) : listgenUserID === "107303" ? (
            <div className="compiled-by-footer-inner-container">
              <p>
                <span className="compiled-by-colon-padding"></span>
                Website: evatia.realestate
              </p>
              <div className="compiled-by-footer-space smaller-space" />

              <p>
                <span className="compiled-by-colon-padding"></span>
                Website: NatalieMacDonald.moreteamhomes.ccm
              </p>
            </div>
          ) : listgenUserID === "104747" ? (
            <div className="compiled-by-footer-inner-container">
              <p>
                <span className="compiled-by-colon-padding"></span>
                Website: SerenaConti.com
              </p>
              <div className="compiled-by-footer-space" />

              <p>
                <span className="compiled-by-colon-padding"></span>
                Website: SheldonRilliet.com
              </p>
            </div>
          ) : listgenUserID === "103486" ? (
            <div className="compiled-by-footer-inner-container">
              <p>
                <span className="compiled-by-colon-padding"></span>
                StanTabler.com
              </p>
              <div className="compiled-by-footer-space" />

              <p>
                <span className="compiled-by-colon-padding"></span>
                KirkHodson.com
              </p>
            </div>
          ) : isShantiAccount && teamMembers?.[1]?.email ? (
            <div className="compiled-by-footer-inner-container">
              <p>
                <span className="compiled-by-colon-padding"></span>
                {displayEmailAddress}
              </p>
              <div className="compiled-by-footer-space" />

              <p>
                <span className="compiled-by-colon-padding"></span>
                {websiteURL.replace(/^www./g, "")}
              </p>
              <div className="compiled-by-footer-space" />
              <p>
                <span className="compiled-by-colon-padding"></span>
                {teamMembers[1].email}
              </p>
            </div>
          ) : websiteURL && websiteURL && listgenUserID === "105047" ? (
            <div
              className="compiled-by-footer-inner-container"
              style={listgenUserID === "105047" ? { fontSize: "11px" } : {}}
            >
              <p>
                Email:<span className="compiled-by-colon-padding"></span>
              </p>
              <div>
                <p>{emailAddress}</p>
                {teamMembers?.[1]?.email && <p>{teamMembers[1].email}</p>}
              </div>

              <div className="compiled-by-footer-space" />

              {websiteURL && (
                <>
                  <p>Website:</p>
                  <span className="compiled-by-colon-padding"></span>
                  <div>
                    <p>{websiteURL.replace(/^www./g, "")}</p>
                    <p>{listgenUserID === "105047" ? " kdavydova.com" : ""}</p>
                  </div>
                </>
              )}
            </div>
          ) : websiteOnly && websiteURL ? (
            <div className="compiled-by-footer-inner-container">
              {websiteURL && (
                <p>
                  Website:<span className="compiled-by-colon-padding"></span>
                  {listgenUserID === "104683"
                    ? "www.terrykellyrealtor.com"
                    : websiteURL.replace(/^www./g, "")}
                  {listgenUserID === "105047" ? " kdavydova.com" : ""}
                </p>
              )}
            </div>
          ) : websiteURL ? (
            <div
              className="compiled-by-footer-inner-container"
              style={listgenUserID === "105047" ? { fontSize: "11px" } : {}}
            >
              <p>
                Email:<span className="compiled-by-colon-padding"></span>
                {emailToUse}
              </p>
              <div
                className={`compiled-by-footer-space ${footerSpaceStyles}`}
              />

              {websiteURL && (
                <p>
                  Website:<span className="compiled-by-colon-padding"></span>
                  {listgenUserID === "104683"
                    ? "www.terrykellyrealtor.com"
                    : websiteURL.replace(/^www./g, "")}
                  {listgenUserID === "105047" ? " kdavydova.com" : ""}
                </p>
              )}
            </div>
          ) : (
            <div className="compiled-by-footer-inner-container center">
              <p>
                Email:<span className="compiled-by-colon-padding"></span>
                {emailToUse}
              </p>
            </div>
          )}
        </div>
      );
    }
  }
}

export default QVFourEmailAndWebsiteFooter;
